<template>
  <div>
    <el-dialog
      :destroy-on-close="true"
      :visible.sync="isFindUnt"
      width="800px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <span>添加单位信息</span>
      </div>
      <div class="dialog-form">
        <div class="user-table">
          <el-table
            :data="tableData"
            style="width: 100%"
            header-row-class-name="table-header"
            header-cell-class-name="table-header-cell"
            :stripe="true"
            :border="true"
          >
            <el-table-column prop="unitName" label="单位名称" align="center">
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template #default="{ row }">
                <span v-if="row.applicationStatus == 1">审核中</span>
                <span v-if="row.applicationStatus == 2">正常关联</span>
                <span v-if="row.applicationStatus == 3">已拒绝</span>
                <span v-if="row.applicationStatus == 4">已解除</span>
                <span v-if="row.applicationStatus == 5">已删除</span>
              </template>
            </el-table-column>

            <div slot="empty" style="text-align: left">
              <el-empty description="暂无数据" :image-size="100" />
            </div>
          </el-table>
        </div>

        <div class="dialog-btns" style="margin-top: 20px">
          <el-button class="cancel" @click="isFindUnt = false">关闭</el-button>
          <el-button class="confirm" @click="isRz">去认证</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="emilVisible"
      width="800px"
      :close-on-click-modal="false"
      @closed="closeEmil"
    >
      <div slot="title" class="dialog-title">
        <span>添加单位信息</span>
      </div>
      <div class="dialog-form">
        <el-form
          :model="emilData"
          ref="elfrom"
          :rules="emilRules"
          label-position="left"
          label-width="100px"
        >
          <el-form-item prop="name" label="姓名">
            <el-input
              :disabled="userInfo && userInfo.name ? true : false"
              v-model="emilData.name"
              placeholder="请输入您的真实姓名"
            ></el-input>
          </el-form-item>

          <el-form-item prop="mail" label="邮箱">
            <el-input
              :disabled="userInfo && userInfo.mail ? true : false"
              v-model="emilData.mail"
              placeholder="请输入您的邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="code"
            label="图片验证码"
            v-show="userInfo && !userInfo.mail"
          >
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.code"
                placeholder="请输入图片验证码"
              ></el-input>
              <div class="verify-img">
                <img @click="getImgCode" :src="emilData.codeImg" alt="" />
              </div>
            </div>
          </el-form-item>

          <el-form-item
            prop="elCode"
            label="验证码"
            v-show="userInfo && !userInfo.mail"
          >
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.elCode"
                placeholder="请输入验证码"
              ></el-input>

              <div
                v-loading="isloading"
                @click="getEmilCode"
                style="text-align: center; line-height: 40px; color: white"
                :class="sendMsgDisabled ? 'verify-img1' : 'verify-img'"
              >
                <span v-if="!sendMsgDisabled">获取验证码</span>
                <span v-if="sendMsgDisabled"> 重新获取 ({{ codeTime }}s) </span>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="study" label="研究领域">
            <el-select
              style="width: 100%"
              v-model="emilData.study"
              multiple
              collapse-tags
              placeholder="请选择"
            >
              <el-option
                v-for="item in studyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- @change="selectchange" -->
          <el-form-item prop="uniName" label="单位名称">
            <el-select
              @focus="clear"
              @hook:mounted="clear"
              @visible-change="clear"
              ref="el-select"
              style="width: 100%"
              v-model="emilData.uniName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入单位名称"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              >
                <template #default>
                  <div v-if="!item.ces">
                    <div @click="selectchange(item.id)">
                      {{ item.unitName }}
                      <!-- <span style="color: #999">{{
                        `(${item.crmId ? "crm" : "企查查"})`
                      }}</span> -->
                    </div>
                  </div>
                  <div
                    @click.stop="addMore"
                    style="
                      font-weight: bold;
                      text-align: center;
                      cursor: pointer;
                      width: 100%;
                      color: var(--ThemeColor);
                    "
                    v-else
                  >
                    未找到想要的单位？
                  </div>
                </template>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="emil" label="纳税识别号">
            <el-input
              disabled
              v-model="emilData.emil"
              placeholder="请输入关键字搜索单位"
            ></el-input>
          </el-form-item>
          <el-form-item prop="cityd" label="单位所在地">
            <!--  rule是否加规则 -->
            <city-selector
              ref="city"
              :rule="false"
              :subcirt-arry="emilData.city"
              @submitt="submitt"
            />
            <el-input
              v-model="emilData.cityd"
              style="display: none; width: 10px; height: 10px"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="address" label="详细地址">
            <el-input
              :disabled="isclass"
              v-model="emilData.address"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>

          <el-form-item prop="class" label="单位分类">
            <el-cascader
              ref="cascader"
              :options="unOptions"
              :disabled="isclass"
              v-model="emilData.class"
              style="width: 100%"
              :props="checkStrictly"
            ></el-cascader>
          </el-form-item>

          <div class="dialog-btns">
            <el-button class="cancel" @click="emilVisible = false"
              >取消</el-button
            >
            <el-button class="confirm" @click="subAddPi">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import userApi from "../../../api/user.js";
import citySelector from "./city.vue";
export default {
  name: "emdialog",
  components: { citySelector },
  computed: {
    ...mapGetters({
      studyOptions: "user/researchOptions",
      userInfo: "user/userInfo"
    })
  },

  data() {
    const reg = /^[\u4e00-\u9fa5]$/;
    var validatePass = (rule, value, callback) => {
      let len = 0;
      for (let i = 0; i < value.length; i++) {
        let word = value.charAt(i); //获取指定位置的字符
        if (!reg.test(word)) {
          //再用正则判断这个字符是否是中文
          //非中文单字节加1
          len++;
        } else {
          //中文单字节加5
          len++;
          // len += 5
        }
      }
      if ((len < 1 && len > 0) || len > 5) {
        // callback(new Error('姓名长度为1-25个字符，一个中文字等于5个字符'))
        callback(new Error("姓名长度为1-5个汉字"));
      } else {
        callback();
      }
    };

    return {
      isloading: false,
      codeTime: 59, //邮箱 发送验证码倒计时
      sendMsgDisabled: false, //邮箱 是否显示获取验证码按钮
      codeInterval: null,
      tableData: [],
      isFindUnt: false,
      checkStrictly: {
        checkStrictly: true
      },
      subItem: {},
      isclasstext: "",
      isclass: true,
      unOptions: [
        {
          value: "option1",
          label: "科研",
          children: [
            {
              value: "00000000002YI",
              label: "高校"
            },
            {
              value: "00000000002YE1",
              label: "科研院所"
            },
            {
              value: "00000000002YG",
              label: "医院"
            }
          ]
        },
        {
          value: "s0pX540K9",
          label: "工业",
          children: [
            {
              value: "00000000002YH",
              label: "企业"
            }
          ]
        },
        {
          value: "Iz5Ljy633",
          label: "军队体系",
          children: [
            {
              value: "00000000002YG",
              label: "医院"
            },
            {
              value: "00000000002YE2",
              label: "研究所"
            }
          ]
        }
      ],

      namejson: "",
      pioptions: [],
      options: [],
      value: [],
      list: [],
      loading: false,

      emilVisible: false,

      emilRules: {
        mail: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入您的邮箱"
          },
          {
            pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
            message: "请输入正确邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        code: [
          {
            required: false,
            trigger: ["change", "blur"],
            message: "请输入图片验证码"
          }
        ],
        elCode: [
          {
            required: false,
            trigger: ["change", "blur"],
            message: "请输入验证码"
          }
        ],
        emil: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入纳税识别号"
          }
        ],
        name: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入您的真实姓名"
          },
          { validator: validatePass }
        ],
        uniName: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入单位名称"
          }
        ],
        cityd: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择单位所在地"
          }
        ],
        address: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入地址"
          }
        ],
        class: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择单位分类"
          }
        ],
        study: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择研究领域"
          }
        ]
      },
      emilData: {
        code: "",
        mail: "",
        city: {},
        name: "",
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
        uniName: "",
        cityd: "",
        address: "",
        class: [],
        study: []
      }
    };
  },
  mounted() {},
  methods: {
    clear() {
      this.$nextTick(() => {
        Array.from(document.getElementsByClassName("el-select")).forEach(
          item => {
            item.children[0].children[0].removeAttribute("readOnly");
            item.children[0].children[0].onblur = function() {
              let _this = this;
              setTimeout(() => {
                _this.removeAttribute("readOnly");
              }, 200);
            };
          }
        );
      });
    },
    getEmilCode() {
      if (this.sendMsgDisabled) {
        return;
      }

      let validateFieldList = [];
      this.$refs["elfrom"].validateField(
        ["mail", "code"],
        async (valid, obj) => {
          if (!valid) {
            validateFieldList.push(valid);

            if (
              validateFieldList.length == 2 &&
              validateFieldList.every(item => item === "")
            ) {
              // 之后的操作
              this.isloading = true;
              userApi
                .getEmilCode({
                  mail: this.emilData.mail,
                  verificationCode: this.emilData.code,
                  verificationCodeKey: this.emilData.codeKey,
                  type: 4
                })
                .then(res => {
                  if (res.code == 200) {
                    this.$message({
                      message: res.data,
                      type: "success"
                    });
                    var _this = this;
                    _this.sendMsgDisabled = true;
                    this.codeInterval = window.setInterval(function() {
                      if (_this.codeTime-- <= 0) {
                        _this.codeTime = 59;
                        _this.sendMsgDisabled = false;
                        _this.getImgCode();
                        window.clearInterval(_this.codeInterval);
                        _this.codeInterval = null;
                      }
                    }, 1000);
                  } else {
                    this.$message.error(res.msg);
                    this.getImgCode();
                  }
                })
                .finally(e => {
                  this.isloading = false;
                });
            }
          }
        }
      );
    },
    getImgCode() {
      userApi.imgcod({ channel: "pc" }).then(res => {
        this.emilData.codeImg = res.data.base64Image;
        this.emilData.codeKey = res.data.codeKey;
      });
    },
    selectchange(e) {
      this.$forceUpdate();
      let item = this.options.filter(res => {
        return res.id == e;
      })[0];
      this.subItem = item;
      if (this.subItem.crmId) {
        this.isclass = true;

        this.setRule();
        let item1 = (this.isclasstext = this.unOptions.filter(reds => {
          return reds.value == item.firstCategory;
        })[0]);

        this.emilData.class = [];
        this.emilData.emil = item.taxpayerNumber;
        this.emilData.address = item.address;

        if (item.firstCategory) {
          this.emilData.class.push(item.firstCategory);
          this.isclasstext = item1.label;
        }
        if (item.secondCategory) {
          this.emilData.class.push(item.secondCategory);
        }
        if (item.billingAddress) {
          this.emilData.address = item.billingAddress;
        }
        if (this.isclass) {
          let params = {
            province: item.province,
            city: item.city,
            isdiplay: true
          };
          this.$refs.city.sub(params);
        } else {
          this.$refs.city.rest();
        }
      } else {
        this.isclass = false;
        userApi
          .findByUniformSocialCreditCode({
            uniformSocialCreditCode: item.taxpayerNumber
          })
          .then(res => {
            if (res.code == 200) {
              let name = this.options.filter(e => {
                return e.id == this.emilData.uniName;
              })[0].unitName;

              res.data.forEach(ee => {
                if (ee.companyName == name) {
                  this.subItem = ee;
                  this.subItem["taxpayerNumber"] =
                    ee.taxpayerIdentificationNumber ||
                    ee.uniformSocialCreditCode;
                }
              });

              // this.subItem = res.data.filter((de) => {
              //   de.companyName == name;
              // })[0];
              this.isclass = true;
            }
            this.setRule();
            let item1 = (this.isclasstext = this.unOptions.filter(reds => {
              return reds.value == this.subItem.firstCategory;
            })[0]);

            this.emilData.class = [];
            this.emilData.emil = this.subItem.taxpayerNumber;
            this.emilData.address = item.address;
            console.log(this.subItem);
            if (this.subItem.firstCategory) {
              this.emilData.class.push(this.subItem.firstCategory);
              this.isclasstext = item1.label;
            }
            if (this.subItem.secondCategory) {
              this.emilData.class.push(this.subItem.secondCategory);
            }
            if (this.subItem.billingAddress) {
              this.emilData.address = this.subItem.billingAddress;
            }
            if (this.isclass) {
              let params = {
                province: this.subItem.province,
                city: this.subItem.city,
                isdiplay: true
              };
              this.$refs.city.sub(params);
            } else {
              this.$refs.city.rest();
            }
          });
      }
    },
    // 提交修改 或新建
    subAddPi() {
      this.$refs["elfrom"].validate(valid => {});
      this.$refs.city.submit().then(res => {
        this.submitForm("form");
      });
    },
    submitt(submitt) {
      this.emilData.city = submitt;
      this.emilData.cityd = submitt[0].Code;
      return new Promise(resolve => {
        if (submitt.length > 0) {
          resolve(1);
        } else {
          resolve(0);
        }
      });
    },

    remoteMethod(qu) {
      let query = qu.trim();
      this.query = query;
      if (query.length > 1) {
        this.options = [];
        this.loading = true;
        setTimeout(() => {
          userApi.findCms({ companyName: query }).then(res => {
            if (res.success) {
              // this.isclass = true;
              this.options = res.data;
              this.options.forEach(el => {
                el["unitName"] = el.companyName;

                if (el.uniformSocialCreditCode) {
                  el["taxpayerNumber"] = el.uniformSocialCreditCode;
                } else if (el.taxpayerIdentificationNumber) {
                  el["taxpayerNumber"] = el.taxpayerIdentificationNumber;
                }
              });
              this.options.push({
                ces: true
              });
              this.loading = false;
            } else {
              userApi
                .myUnit({ channel: "pc", unitName: this.query })
                .then(ress => {
                  this.$refs.city.restRule();
                  this.options = ress.data;
                  this.loading = false;
                  this.options.forEach((rel, ind) => {
                    rel["id"] = ind;
                  });

                  this.emilData.cityd = "";
                  this.checkStrictly.checkStrictly = false;
                });
            }
          });
        }, 300);
      }
    },
    addMore() {
      userApi.myUnit({ channel: "pc", unitName: this.query }).then(ress => {
        this.loading = true;

        this.$refs.city.restRule();
        let arr = ress.data;
        arr.forEach((rel, ind) => {
          rel["id"] = ind + "qcc";
        });

        this.options = [...this.options.slice(0, -1), ...arr];
        this.loading = false;

        // this.emilData.cityd = "";
        // this.checkStrictly.checkStrictly = false;
      });
    },
    getNotAuthenticationPiList(type) {
      this.$loading.show();
      userApi.getNotAuthenticationPiList().then(res => {
        if (res.code == 200) {
          console.log(res, "-res--");
          if (res.data && res.data.length > 0) {
            this.isFindUnt = true;
            this.tableData = res.data;
            this.$loading.hide();
          } else {
            userApi
              .unitInfoList({
                channel: "pc",
                customerId: this.userInfo.customerId,
                page: 1,
                size: 999,
                type: 1
              })
              .then(res => {
                if (res.code == 200) {
                  //
                  this.getUni();
                } else {
                  this.getUni();
                }
                this.$loading.hide();
              });
          }
        }
      });
    },
    isRz() {
      this.isFindUnt = false;

      this.$loading.show();
      this.clear();
      userApi
        .unitInfoList({
          channel: "pc",
          customerId: this.userInfo.customerId,
          page: 1,
          size: 999,
          type: 1
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data[0] && res.data[0].customerName) {
              this.emilData.name = res.data[0].customerName;
            }
            this.getUni();
          } else {
            this.getUni();
          }
          this.$loading.hide();
        });
    },
    async ishow(type) {
      if (
        this.userInfo.isSalesCustomers &&
        this.userInfo.isSalesCustomers == 1
      ) {
        this.$message.error("销售账户不能认证");
        return;
      }
      if (this.userInfo && !this.userInfo.mail) {
        this.emilRules.elCode[0].required = true;
        this.emilRules.code[0].required = true;
        this.getImgCode();
      } else if (this.userInfo && this.userInfo.mail) {
        this.emilData.mail = this.userInfo.mail;
      }

      if (this.userInfo.researchField) {
        let arr = [];
        this.userInfo.researchField.split(",").forEach(e => {
          if (
            this.studyOptions.filter(ee => {
              return e == ee.label;
            })[0]
          ) {
            arr.push(
              this.studyOptions.filter(ee => {
                return e == ee.label;
              })[0].value
            );
          }
        });
        this.emilData.study = arr;
      }

      if (this.userInfo.name) {
        this.emilData.name = this.userInfo.name;
      }
      if (type == "1") {
        this.emilVisible = true;
        return;
      }
      this.getNotAuthenticationPiList();
    },
    getUni() {
      this.emilVisible = true;
      this.clear();
    },
    setRule() {
      if (this.isclass) {
        // this.emilRules.elCode[0].required = false;
        this.emilRules.emil[0].required = false;
        this.emilRules.cityd[0].required = false;
        this.emilRules.address[0].required = false;
        this.emilRules.class[0].required = false;
      } else {
        // this.emilRules.elCode[0].required = true;
        this.emilRules.emil[0].required = true;
        this.emilRules.cityd[0].required = true;
        this.emilRules.address[0].required = true;
        this.emilRules.class[0].required = true;
      }
      this.$refs["elfrom"].clearValidate();
    },
    submitForm() {
      this.setRule();
      this.$refs["elfrom"].validate(valid => {
        if (valid) {
          let params = {};
          if (this.isclass) {
            // crm的 emilData.uniName
            params = {
              customerId: this.userInfo.customerId, //客户Id
              customerName: this.emilData.name,
              channel: "pc",
              unitName: this.options.filter(e => {
                return e.id == this.emilData.uniName;
              })[0].unitName,
              taxpayerNumber: this.emilData.emil,
              applicationType: this.isclass ? 1 : 2,

              unitCrmId: this.subItem.crmId,
              researchField: this.emilData.study.join(",")
            };
            // owner: this.subItem.owner ? this.subItem.owner[0] : "",
            if (this.subItem.owner) {
              params["owner"] = this.subItem.owner[0];
            }
            if (this.subItem.city) {
              params["city"] = this.subItem.city;
            }
            if (this.subItem.province) {
              params["economize"] = this.subItem.province;
            }
            if (this.emilData.class[0]) {
              params["firstCategory"] = this.emilData.class[0];
            }
            if (this.emilData.class[1]) {
              params["secondCategory"] = this.emilData.class[1];
            }
          } else {
            params = {
              customerId: this.userInfo.customerId, //客户Id
              customerName: this.emilData.name,
              channel: "pc",
              city: this.emilData.city[1].Name,
              cityId: this.emilData.city[1].Code,
              distinguish: this.emilData.city[2].Name,
              distinguishId: this.emilData.city[2].Code,
              economize: this.emilData.city[0].Name,
              economizeId: this.emilData.city[0].Code,
              address: this.emilData.address,

              unitName: this.options.filter(e => {
                return e.id == this.emilData.uniName;
              })[0].unitName,
              taxpayerNumber: this.emilData.emil,
              applicationType: this.isclass ? 1 : 2,
              firstCategory: this.emilData.class[0]
                ? this.emilData.class[0]
                : null,
              researchField: this.emilData.study.join(","),

              secondCategory: this.emilData.class[1]
                ? this.emilData.class[1]
                : null
            };
          }

          if (this.emilData.mail) {
            params["mail"] = this.emilData.mail;
          }
          if (this.emilData.elCode) {
            params["mailCode"] = this.emilData.elCode;
          }

          let arr2 = [];
          this.emilData.study.forEach(e => {
            if (
              this.studyOptions.filter(ee => {
                return e == ee.value;
              })[0]
            ) {
              arr2.push(
                this.studyOptions.filter(ee => {
                  return e == ee.value;
                })[0].label
              );
            }
          });

          params["researchFieldName"] = arr2.join(",");
          console.log(params);

          this.$loading.show();
          userApi.addUnit(params).then(res => {
            if (res.code == 200) {
              this.$message.success(res.data);
              this.emilVisible = false;
              this.$emit("getUser", "1");
            } else {
              this.$message.error(res.msg);
            }
            this.$loading.hide();
          });
        }
      });
    },
    closeEmil() {
      this.options = [];
      this.emilData = {
        mail: "",
        name: "",
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
        code: "",
        uniName: "",
        city: {},
        address: "",
        class: [],
        study: [],
        cityd: ""
      };
      this.$refs["elfrom"].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-title {
  text-align: left;
  font-size: 30px;
  color: #000;
  border-bottom: 4px solid #e5e5e5;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding-bottom: 20px;
  padding-left: 60px;
  position: relative;

  span {
  }

  &::before {
    display: block;
    content: "";
    width: 65px;
    height: 4px;
    background-color: var(--ThemeColor);
    position: absolute;
    bottom: -4px;
    left: 60px;
  }
}

.dialog-form {
  padding: 0 60px;
  text-align: left;

  .get-verify {
    width: 100%;
    background-color: #3c4250;
    color: var(--textWhite);
  }

  .dilog-select {
    width: 100%;
  }

  .dialog-btns {
    text-align: center;

    .cancel,
    .confirm {
      font-size: 16px;
    }

    .confirm {
      color: var(--textWhite);
      background-color: var(--ThemeColor);
    }
  }
}

.user-table {
  margin-top: 20px;

  /deep/.table-header {
    background-color: var(--ThemeColor) !important;
    color: var(--textWhite);
    font-size: 16px;
  }

  /deep/.table-header-cell {
    background-color: transparent;
    border: none;
  }

  /deep/.el-table__header-wrapper {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  /deep/.el-table__cell {
    border-color: #c5c5c5;
  }

  /deep/.el-table__body {
    // border-left: 1px solid #c5c5c5;
  }

  /deep/.el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    background-color: #eff0f0;
  }

  /deep/.el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #c5c5c5;
  }
}

.pagination {
  margin-top: 55px;

  /deep/.el-pager li {
    border: 1px solid #c6c6c6;
    font-size: 16px;
    font-weight: normal;
    border-radius: 3px;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--ThemeColor);
  }

  /deep/.btn-prev i {
    font-size: 26px;
    color: var(--ThemeColor);
  }

  /deep/.btn-pre[disabled="disabled"] i {
    font-size: 26px;
    color: var(--textGray) !important;
  }

  /deep/.btn-next i {
    font-size: 26px;
    color: var(--ThemeColor);
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.verify-img {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--ThemeColor);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}

.verify-img1 {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--textGray);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/pi.vue